<template>
    <div class="hiq-public-art__load-more">
        <button class="hiq-public-art__load-more--button" @click="loadMore">
            {{translations.loadMore}}
            <span class="show-for-sr">{{translations.worksOfArt}}</span>
        </button>
    </div>
</template>

<script>
import { newSearch } from '../store/actions';
export default {
    name: 'load-more',
    methods: {
        loadMore() {
            this.$store.commit({
                type: 'setPage',
                payload: this.page + 1
            });
            this.$store.dispatch(newSearch())
        }
    },
    computed: {
        page() {
            return this.$store.state.art.page;
        },
        translations() {
            return this.$store.state.translations;
        }
    }
}
</script>